export default "__VITE_ASSET__CsbmSe2u__"